import { useMutation } from '@src/query';


/**
 * Settings → Business mutation hook (T10). Wraps the shared `useMutation` engine
 * with the injected-`queryClient` `mutateFn({ apiClient, queryClient })`
 * contract — the corelib query singleton is NOT imported here. Invalidation runs
 * inside `mutateFn`; the caller passes the `/sellers/mine/` `queryKey` it already
 * holds from `useMineQuery` (a PATCH to the seller invalidates the org), so the
 * exact cache key is preserved unchanged.
 *
 * Mirrors `query/garage/useDonorMutations.js`. Backs both the 9-field details
 * form and the logo upload/remove (multipart vs JSON via `contentType`).
 */

/** PATCH the org's business details or logo. Variables: `{ sellerId, payload,
 * contentType, queryKey }`. */
function useBusinessSaveMutation(params) {
  return useMutation({
    mutateFn: ({ apiClient, queryClient, sellerId, payload, contentType, queryKey }) => apiClient
      .request({ url: `/sellers/${sellerId}/`, method: 'PATCH', payload, contentType })
      .then((data) => {
        queryClient.invalidateQueries({ queryKey });
        return data;
      }),
    ...params,
  });
}


export { useBusinessSaveMutation };
